<template>
  <div class="report-chart-container" :class="containerClass">
    <ReportFilterBadge :metadata="data.metadata" />
    <div class="report-chart-canvas" :style="canvasStyle">
      <component :is="chartComponent" :data="data" />
    </div>
  </div>
</template>

<script>
  import ReportFilterBadge from '@/components/elements/ReportFilterBadge'

  export default {
    name: 'ReportChartContainer',
    components: { ReportFilterBadge },
    props: {
      data: {
        type: Object,
        required: true
      },
      chartComponent: {
        type: Object,
        required: true
      }
    },
    computed: {
      layout () {
        return (this.data && this.data.layout) || {}
      },
      layoutType () {
        return this.layout.type || 'line'
      },
      containerClass () {
        return 'report-chart-container--' + this.layoutType
      },
      canvasStyle () {
        const minHeight = this.layout.minHeight || 420

        if (this.layoutType === 'doughnut') {
          return {
            width: '480px',
            height: '480px',
            margin: '0 auto'
          }
        }

        if (this.layoutType === 'horizontalBar') {
          return {
            width: '100%',
            maxWidth: '760px',
            height: minHeight + 'px',
            minHeight: minHeight + 'px',
            margin: '0 auto'
          }
        }

        return {
          width: '100%',
          maxWidth: '760px',
          height: minHeight + 'px',
          minHeight: minHeight + 'px',
          margin: '0 auto'
        }
      }
    }
  }
</script>

<style scoped>
  .report-chart-container {
    display: block;
    width: 100%;
    margin: 0 auto 12px;
    text-align: center;
    overflow: visible;
  }
  .report-chart-canvas {
    position: relative;
    overflow: visible;
  }
  .report-chart-container--bar .report-chart-canvas >>> canvas {
    display: block;
    margin: 0 auto;
  }
  .report-chart-container--doughnut .report-chart-canvas >>> canvas {
    max-width: 480px;
    max-height: 480px;
  }
</style>



// WEBPACK FOOTER //
// ReportChartContainer.vue?b141dcf6